<template>
  <aside id="slider" class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel -->
      <div class="user-panel">
        <div class="text-center image">
          <img
            class="profile-user-img img-fluid img-circle"
            :src="logo"
            alt="Company Logo"
          />
          <p class="text-center" v-if="getRecord.shortName"><strong>{{ getRecord.shortName.toUpperCase() }}</strong></p>
        </div>
        <div class="image text-center">
          <!-- <img src="~admin-lte/dist/img/user2-160x160.jpg" class="img-circle" alt="User Image"> -->
          <div v-if="currentUser.role_id !== 1">
            <img
              class="profile-user-img img-circle"
              :src="photo"
              alt="User profile picture"
            />
          </div>
          <div class="text-center" v-else>
            <i class="fa fa-user" style="font-size: 45px;"></i>
          </div>
        </div>
        <div v-if="this.$store.state.user.name" class=" info">
          <p> {{ currentUser.name.toUpperCase() }}</p>
          <router-link to="/"><i class="fa fa-circle" :style="`color:green;`"></i><b>Role:</b> {{ currentUser.role.name }}</router-link>
        </div><br><br>
      </div>
      <!-- search form -->
      <!-- <form action="#" method="get" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search...">
              <span class="input-group-btn">
                <button type="submit" name="search" id="search-btn" class="btn btn-flat"><i class="fa fa-search"></i>
                </button>
              </span>
        </div>
      </form> -->
      <!-- /.search form -->
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul data-widget="tree" class="sidebar-menu">
        <va-slide-item
          v-for="(item,index) in slideMenuItems"
          :data="item"
          :key="index"
          :type="item.type"
          :isHeader="item.isHeader"
          :icon="item.icon"
          :name="item.name"
          :badge="item.badge"
          :items="item.items"
          :router="item.router"
          :link="item.link"
        >
        </va-slide-item>
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import VASlideItem from './components/VASlideItem'

export default {
  name: 'va-slider',
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    ...mapState([
      'profile'
    ])
  },
  data () {
    return {
      photo: 'https://via.placeholder.com/100/FFFF00/000000?text=Photo',
      logo: 'https://via.placeholder.com/100/FFFF00/000000?text=Logo',
      getRecord: {}
    }
  },
  props: {
    slideMenuItems: {
      type: Array,
      default: []
    }
  },
  methods: {
    loadData () {
      if (this.profile.photo != null) {
        this.photo = this.$store.state.imageBaseUrl + this.profile.user_id + '/photo/' + this.profile.photo
      } else {
        this.photo = 'https://via.placeholder.com/100/ffefda/000000?text=Photo'
      }
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getRecord = data
          // Change Document Title
          if (this.getRecord.companyName != null) {
            document.title = this.getRecord.companyName
          }
          // Change Document Favicon
          if (this.getRecord.companyName != null) {
            document.getElementById('favicon').setAttribute('href', this.$store.state.imageBaseUrl + 'favicon/' + this.getRecord.favicon)
          }
          if (this.getRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getRecord.logo
          } else {
            console.log(this.getRecord)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
  },
  components: {
    'va-slide-item': VASlideItem
  }
}
</script>
<style scoped>
.main-sidebar, .skin-black-light .left-side {
  background-color: #fff;
}
.skin-black-light .sidebar-menu > li.active > a {
  color: #000;
  background: #f4f4f5;
}
</style>



// WEBPACK FOOTER //
// Slider.vue?24b8c63c